import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import MemberDesign from './member-design/MemberDesign';
import './index.css';
import './components/precision/feature-tour.css';
import { AuthProvider } from './context/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebaseApp';
import { refreshPushRegistration } from './features/notifications/push';
onAuthStateChanged(auth, user => {
  if (user) void refreshPushRegistration().catch(() => { /* Retry on the next visit; profile provides manual controls. */ });
});

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <BrowserRouter>
    <AuthProvider>
      <MemberDesign><App /></MemberDesign>
    </AuthProvider>
  </BrowserRouter>
);
